export default "__VITE_ASSET__kMtbU4SJ__"